"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const users_1 = require("./users");
const fields = `
    id
    subTopic
    action
    createdAt
    payload
    resourceUrl
    targetUser {
      ...basicUserDetailData
    }
    creatingUser {
      ...basicUserDetailData
    }
    workspace {
      id
      name
    }
    message
    __typename
`;
exports.messageDetailData = graphql_tag_1.default `
  fragment messageDetailData on OsmosysMessage {
    ... on OsmosysMessage {
      ${fields}
    }
  }
  ${users_1.basicUserDetailData}
`;
//# sourceMappingURL=messages.js.map